module.exports = __webpack_public_path__ + "img/poster-bg.d1386d81.jpg";